// Shapes the proctoring payload (getProctoringDetails) for the student report.
//
// One attempt can hold MORE THAN ONE proctoring session: the candidate
// reconnected, or — the common case — the webcam capture taken as they hit
// submit reached the server after the session was closed and opened a session
// of its own holding that single snapshot. admin-node returns sessions
// newest-first, so reading `sessions[0]` rendered exactly that stray image and
// hid the 60-250 real ones. student-node no longer creates those stray sessions,
// but attempts already recorded still carry them, so the report reads across
// every session.
//
// See proctoringView.test.js.

// Every snapshot of the attempt, oldest capture first.
const collectSnapshots = (sessions = []) =>
  sessions
    .flatMap(session => session?.snapshots || [])
    .sort((a, b) => new Date(a.capturedAt) - new Date(b.capturedAt))

// The session the candidate actually sat in — the richest one, never a
// straggler that holds a lone post-submit snapshot.
const primarySession = (sessions = []) =>
  sessions.reduce(
    (longest, session) =>
      (session?.snapshots?.length || 0) > (longest?.snapshots?.length || 0)
        ? session
        : longest,
    sessions[0] || {}
  )

// IPs seen across the whole attempt.
const collectIpAddresses = (sessions = []) =>
  sessions.flatMap(session => session?.ipAddresses || [])

module.exports = {
  collectSnapshots,
  primarySession,
  collectIpAddresses,
}
